module.exports = __webpack_public_path__ + "static/media/rfid2.d0cb0382.jpg";